import React from 'react';
import './Home.css';

const Home = () => {
  return (
    <div className="home-container">
      <div className="hero-message">
        <h2>Get to market faster so your children may reap the benefits soon</h2>
        <p>Join us in making a difference for future generations</p>
      </div>
    </div>
  );
};

export default Home; 